export enum ListProducts {
  SPORTS = 1,
  LIVE_SPORTS = 2,
  CASINO = 3,
  LIVE_CASINO = 4,
  HORSES = 5,
}
